import { defineStore } from 'pinia';
import getters from './getters';

function initState() {
    return {
        listData: [],
        countMap: {}
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    getters,
    actions: {}
});
